// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info[data-v-737f0c85]{position:relative;color:#000;padding:20px;border-radius:6px;display:block;z-index:10}.info span[data-v-737f0c85]{font-size:1.2rem;width:100%;margin-bottom:0}@media only screen and (min-width:1025px){.info span[data-v-737f0c85]{font-size:1.64rem;width:70%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
